// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://uxufperywgqgdcfuubng.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4dWZwZXJ5d2dxZ2RjZnV1Ym5nIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI2MjgwNTUsImV4cCI6MjA1ODIwNDA1NX0.rIDp1-vQOdVVsPvGXXjfrU80LBFQf5Z_5Q4IJ3kQ4ec";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);